export function pushLeadEvent(formName: string, extra?: Record<string, any>) {
  try {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: "lead_submitted",
      form_name: formName,
      ...extra
    });
  } catch {}
}
